import { render } from "./FormTabs.vue?vue&type=template&id=03676966&scoped=true"
import script from "./FormTabs.vue?vue&type=script&lang=js"
export * from "./FormTabs.vue?vue&type=script&lang=js"

import "./FormTabs.vue?vue&type=style&index=0&id=03676966&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03676966"]])

export default __exports__